import LoadingButton from '@atlaskit/button/loading-button';
import Button from '@atlaskit/button/standard-button';
import { useFlags } from '@atlaskit/flag';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { deletePartnerContact } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { getFlagForError, getFlagForSuccess } from "../../../utils/FlagUtils";

const DeleteContactConfirmationModal = props => {
  const {
    showFlag
  } = useFlags();
  const [deletingContactInProgress, setDeletingContactInProgress] = useState(false);

  const onDeleteContact = async () => {
    setDeletingContactInProgress(true);

    try {
      await deletePartnerContact(props.mpacBaseUrl, props.contactResource);
      setDeletingContactInProgress(false);
      props.onDelete();
      showFlag(getFlagForSuccess('deleteContactSuccess', "".concat(props.contactName, " has been successfully deleted")));
    } catch (error) {
      setDeletingContactInProgress(false);
      showFlag(getFlagForError('deleteContactFailure', 'Deleting contact failed'));
      log.error('PartnerContactsActions', "Failed to delete a contact", {
        error
      });
    }
  };

  return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(Modal, {
    onClose: props.onCloseModal
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, {
    appearance: "danger"
  }, "Delete contact")), /*#__PURE__*/React.createElement(ModalBody, null, "Are you sure you want to remove ", props.contactName, "?"), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(LoadingButton, {
    appearance: "danger",
    isLoading: deletingContactInProgress,
    onClick: onDeleteContact
  }, "Delete now"), /*#__PURE__*/React.createElement(Button, {
    onClick: props.onCloseModal
  }, "Cancel"))));
};

export default DeleteContactConfirmationModal;